module.exports = __webpack_public_path__ + "static/whitegiraffehamper-5aff74aefb665f53da1e109620de5e7e.jpeg";